import { InputLabel, StyledIcon } from "../custom-styles/new-edit-form/NewEditForm.styles";

import ContactCard from "shared/components/data-display/drawers/ContactCard";
import HStack from "shared/components/layout/stack/HStack";
import PropTypes from "prop-types";
import React from "react";
import Text from "shared/components/data-display/text/Text";
import VStack from "shared/components/layout/stack/VStack";
import env from "react-dotenv";
import { format } from "date-fns";

const ApprovedOrRejectedFormInfo = ({
    currentTimeOfRequest,
    isRejectedRequest,
    noApproverAssigned,
    approver
}) => {

    return (
        <>
            <VStack>
                <HStack justify="space-between">
                    <InputLabel
                        variant="Descriptive_2_1"
                        color="Gray_4"
                    >
                        Request Decision
                    </InputLabel>
                    {currentTimeOfRequest?.approvedHRDate && (
                        <Text
                            variant="Descriptive_2_1"
                            color="Gray_4"
                        >
                            Reviewed{" "}
                            {format(
                                new Date(currentTimeOfRequest.approvedHRDate),
                                "MMM dd, yyyy"
                            )}
                        </Text>
                    )}
                </HStack>
                <HStack spacing="Zero_5">
                    <StyledIcon
                        size={17}
                        name={isRejectedRequest ? "error" : "success"}
                        color={isRejectedRequest ? "Orange_1" : "Green"}
                    />
                    <Text variant="Body_1_2" color="Black">
                        {currentTimeOfRequest?.status}
                    </Text>
                </HStack>
            </VStack>
            {!noApproverAssigned && !approver.isLoading && (
                <ContactCard
                    photoUrl={
                        env.BESTWORK_REACT_ASSET_DOMAIN +
                        "/" +
                        approver?.data.SmallPhotoUrl
                    }
                    name={approver?.data.FullName}
                    jobPost={approver?.data.Title}
                    department={approver?.data.Department}
                    emailId={approver?.data.Email}
                    contactCardLabel="Request Reviewed by"
                    contactCardLabelVariant="Body_2_2"
                    contactCardLabelColor="Gray_1"
                />
            )}
        </>
    );
};

ApprovedOrRejectedFormInfo.propTypes = {
    currentTimeOfRequest: PropTypes.object,
    isRejectedRequest: PropTypes.bool,
    noApproverAssigned: PropTypes.bool,
    approver: PropTypes.object
};

export default ApprovedOrRejectedFormInfo;